import fields from "../../assets/data/TkFileEncodeProperty";

/**
 * ファイルbase64エンコード部品
 * ファイル名を引数にとって、結果コード、ファイル名、ファイルデータ(base64)を返す
 *
 * @see TkfileUpload
 * @todo メッセージバー用の処理をメッセージバー完成後記載する。
 * @param file : ダイヤログから選択されたファイル
 * @return resultInfo : 結果コード(メッセージID)、ファイル名、ファイルデータ
 **/
type resultInfo = {
  messeageid: string;
  filename: string;
  base64result: string;
};

export function fileToBase64check(file: File) {
  let resultErrMessage = "";
  //選択したファイルデータがないとき
  if (!file) {
    resultErrMessage = "TKMSG_SCR0004E";
    return resultErrMessage;
  }

  // 許可された拡張子かどうかを確認
  let ischeckFileExtension: boolean = false;
  ischeckFileExtension = isExtensionValid(file.name);
  if (!ischeckFileExtension) {
    resultErrMessage = "TKMSG_SCR0005E";
    return resultErrMessage;
  }

  const size = getFileSize(file);
  let maxFileSize = getValueBytes();
  if (size > maxFileSize) {
    resultErrMessage = "TKMSG_SCR0006E";
    return resultErrMessage;
  }
  return resultErrMessage;
}

export function FileToBase64encode(file: File): Promise<resultInfo> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let result: resultInfo = {
        messeageid: "",
        filename: file.name,
        base64result: (reader.result as string),
      };
      resolve(result);
    };
    reader.onerror = () => {
      reject(new Error("Failed to read file"));
    };
  });
}

function getFileSize(file: File): number {
  // ファイルサイズをバイト単位で取得
  return file.size;
}

function getValueBytes() {
  // 定数ファイルからファイルサイズをバイト単位で取得
  return fields.file.maxFileSize.value_bytes;
}

//ファイルの拡張子を取得して許可された拡張子かどうかを確認する関数
function isExtensionValid(filename: string): boolean {
  const fileExtension = filename.slice(
    ((filename.lastIndexOf(".") - 1) >>> 0) + 2
  );
  const validExtensions = fields.file.extension.split(",");
  return validExtensions.includes(`.${fileExtension}`);
}